import React from "react";
import ScrollToTop from "./ScrollToTop";
import logo from "./assets/Roimages/Logo.png";
import { Link } from "react-router-dom";
import WhatsAppButton from "./WhatsAppButton";

const Footer = () => {
  const today = new Date();
  const year = today.getFullYear();

  return (
    <>
      <footer className="footer-area">
        <div className="widget-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-7 col-sm-7 col-12 order-lg-1 order-md-1 order-sm-1 order-1 mobile-footer-widget text-md-start text-sm-start text-center">
                <div className="footer-widget">
                  <Link to="/" className="d-inline-block mb-4">
                    <img
                      alt="Bliss Water Technology logo"
                      src={logo}
                      className="logo-footer"
                      loading="lazy"
                    />
                  </Link>

                  <p className="text-white mb-25">
                    Bliss Water Technology helps you buy and sell new and used
                    RO plants and water filters. Get clean and safe water with
                    our low-cost and trusted systems.
                  </p>

                </div>
              </div>

              <div className="col-lg-2 col-md-4 col-sm-4 col-4 order-lg-1 order-md-3 order-sm-3 order-1 mobile-footer-widget text-start">
                <div className="footer-widget">
                  <h4>About Us</h4>
                  <ul className="link p-0">
                    <li>
                      <Link className="text-decoration-none" to="/">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link className="text-decoration-none" to="/product">
                        Product
                      </Link>
                    </li>
                    <li>
                      <Link className="text-decoration-none" to="/blog">
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link className="text-decoration-none" to="/contact">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-2 col-md-4 col-sm-4 col-8 order-lg-1 order-md-4 order-sm-4 order-1 mobile-footer-widget text-start">
                <div className="footer-widget">
                  <h4>Information</h4>
                  <ul className="link p-0">
                    <li>
                      <Link to="/terms-conditions">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link to="/privacy-policy">Privacy Policy</Link>
                    </li>
                    <li>
                      <Link to="/billing-shipping-policy">
                        Shipping Information
                      </Link>
                    </li>
                    <li>
                      <Link to="/return-exchange-policy">
                        Returns & Exchanges
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-2 col-md-4 col-sm-4 col-4 order-lg-1 order-md-5 order-sm-5 order-1 mobile-footer-widget text-start">
                <div className="footer-widget">
                  <h4>Support</h4>
                  <ul className="link p-0">
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                    <li>
                      <Link to="/faqs">FAQs</Link>
                    </li>
                    <li>
                      <Link to="/cookie-policy">Cookie Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-5 col-sm-5 col-8 order-lg-1 order-md-2 order-sm-2 order-1 mobile-footer-widget text-start">
                <div className="footer-widget">
                  <h4>Quick Contact</h4>
                  <ul className="link p-0">
                    <li>
                      <a
                        href="tel:+919265199516"
                        className="mobile-fw-bold text-decoration-none d-flex align-items-center"
                      >
                        <i className="bi bi-telephone me-2"></i> +91 92651 99516
                      </a>
                    </li>
                    <li>
                      <a
                        href="mailto:blisswatertechnology@gmail.com"
                        title="Email us at blisswatertechnology@gmail.com"
                        className="mobile-fw-bold text-decoration-none d-flex align-items-center"
                      >
                        <i className="bi bi-envelope me-2"></i>{" "}
                        blisswatertechnology@gmail.com
                      </a>
                    </li>
                  </ul>
                  <ul className="social p-0">
                    <li>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        aria-label="WhatsApp"
                        href="https://wa.me/919265199516"
                      >
                        <i className="bi bi-whatsapp"></i>
                      </a>
                    </li>
                    <li>
                      <Link
                        target="_blank"
                        rel="noreferrer"
                        to="https://www.facebook.com/profile.php?id=61574686574202"
                      >
                        <i className="bi bi-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        target="_blank"
                        rel="noreferrer"
                        to="https://www.instagram.com/bliss_water_51/"
                      >
                        <i className="bi bi-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="copy-right text-center p-3">
        <span className="text-decoration-none text-light footerBgtxt">
          All rights reserved. Copyright © {year}
          <a
            href="/"
            rel="noreferrer"
            className="footer01 text-decoration-none text-light mx-1"
          >
            Bliss Water Technology
          </a>
          Powered By
          <a
            href="https://liontouchwebpark.com/"
            rel="noreferrer"
            target="_blank"
            className="footer01 text-decoration-none text-light ms-1"
          >
            Liontouch Webpark.
          </a>
        </span>
      </div>

      <WhatsAppButton />
      <ScrollToTop />
    </>
  );
};

export default Footer;
